export default {
  getListStatus (state) {
    return state.list_status
  }
}



// WEBPACK FOOTER //
// ./src/store/module/checklist-item-status/getters.js